<div class="c-modal c-modal--sm" id="modal-{{vm.uid}}">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p style="font-size: 22px">
						{{ 'TherapyFundWallet.AddWallet' | translate }} 
					</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close"
							(click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<form name="vm.form" #mainForm="ngForm" class="c-form u-ost-md">
					<div class="o-grid o-grid--wrap" *ngIf="vm.initialized">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || personalCode.dirty) && (personalCode.invalid || vm.personalCodeFailed) }">
								<label for="personalCode" class="c-form__label c-form__label">
								    {{ 'TherapyFundWallet.PersonalCode' | translate }}
								</label>
								<div>
								    <input id="{{ 'personalCode-' + vm.uid }}" name="personalCode" #personalCode="ngModel" type="text" class="c-form__input c-form__input--sm" [(ngModel)]="vm.wallet.user.personalCode" maxlength="11" required>
								</div>
								<item-form-error *ngIf="vm.personalCodeFailed" [fieldName]="'TherapyFundWallet.PersonalCode' | translate" [error]="{'pattern':true}"></item-form-error>
							</div>
							<div class="c-form__group u-osb-lg" [ngClass]="{ 'c-form__group--error': (vm.submitted || balance.dirty) && balance.invalid }">
								<label for="balance" class="c-form__label c-form__label">
								    {{ 'TherapyFundWallet.Balance' | translate }}
								</label>
								<div>
								    <input id="{{ 'balance-' + vm.uid }}" name="balance" #balance="ngModel" type="text" class="c-form__input c-form__input--sm" [(ngModel)]="vm.wallet.balance" maxlength="11" required>
								</div>
							</div>
							<div class="c-form__group u-osb-lg">
								<label for="validFrom" class="c-form__label c-form__label">
								    {{ 'TherapyFundWallet.ValidFrom' | translate }}
								</label>
								<div id="datePickerContainer">
								    <input-datepicker-new id="{{ 'valid-from-' + vm.uid }}"
					                      name="validFrom"
					                      [(model)]="vm.wallet.validFrom"
					                      [minDate]="vm.minDate"
					                      [startDate]="vm.defaultStartDate"
					                      data-el-parent="datePickerContainer" 
					                      [hasTimepicker]="false"
					                      [hasCalendarIcon]="true"
					                      [isSingleDate]="true"
					                      [isFixedPosition]="true"></input-datepicker-new>
								</div>
							</div>
							<div class="c-form__group u-osb-lg">
								<label class="c-form__label c-form__label">
								    {{ 'TherapyFundWallet.ValidTo' | translate }}
								</label>
								<div id="datePickerContainer">
								    <input-datepicker-new id="{{ 'valid-to-' + vm.uid }}"
					                      name="validTo"
					                      [(model)]="vm.wallet.validTo"
					                      [minDate]="vm.minDate"
					                      [startDate]="vm.defaultEndDate"
					                      data-el-parent="datePickerContainer" 
					                      [hasTimepicker]="false"
					                      [hasCalendarIcon]="true"
					                      [isSingleDate]="true"
					                      [isFixedPosition]="true"></input-datepicker-new>
								</div>
							</div>
						</div>
					</div>
					<div class="c-panel u-no-p u-ost-sm u-osb-sm">
						<button type="button"
	                            id="createTherapyFundWalletButton"
								(click)="vm.submit(mainForm)"
								[disabled]="vm.processing || !vm.initialized"
								class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
							{{ 'Modal.Button.Create' | translate }}
						</button>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
